import React from "react";
import { useTranslation } from "react-i18next";
import {
  resolveVolumeLimit,
  resolveVolumeUsage,
} from "util/planEntitlements";
import PlanProgressBar from "./PlanProgressBar";
import styles from "./style.module.scss";

const PlanVolumeUsage = ({ coreEntitlement, loading }) => {
  const { t } = useTranslation();
  const used = coreEntitlement ? resolveVolumeUsage(coreEntitlement) : 0;
  const limit = coreEntitlement ? resolveVolumeLimit(coreEntitlement) : null;
  const overageRate = coreEntitlement?.overage_unit_rate;
  const isOver = limit != null && limit > 0 && used > limit;

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{t("settings.plan_volume_usage_title")}</h3>
      {loading && !coreEntitlement ? (
        <p className={styles.sectionHint}>{t("settings.plan_loading")}</p>
      ) : (
        <PlanProgressBar
          label={t("settings.plan_volume_usage_label")}
          used={used}
          max={limit}
          footer={
            isOver && overageRate != null ? (
              <p className={styles.quotaRenewalHint}>
                {t("settings.plan_volume_overage_note", {
                  rate: overageRate,
                  currency: coreEntitlement?.currency || "USD",
                })}
              </p>
            ) : limit == null || limit <= 0 ? (
              <p className={styles.quotaRenewalHint}>
                {t("settings.plan_volume_unlimited")}
              </p>
            ) : null
          }
        />
      )}
    </div>
  );
};

export default PlanVolumeUsage;
